import React from 'react';
import { Volume1, Volume2, VolumeX } from 'lucide-react';

interface IntensitySliderProps {
  value: number;
  onChange: (value: number) => void;
  className?: string;
}

const INTENSITY_LEVELS = [
  {
    level: 1,
    name: 'Very Gentle',
    description: 'Soft reminders and encouragement',
    example: '"When you\'re ready, your goal is waiting for you."',
    icon: VolumeX
  },
  {
    level: 2,
    name: 'Gentle',
    description: 'Friendly nudges and support',
    example: '"Hope you\'re having a good day! Ready to tackle your goal?"',
    icon: VolumeX
  },
  {
    level: 3,
    name: 'Balanced',
    description: 'Mix of encouragement and accountability',
    example: '"Time to focus on your goal. You\'ve got this!"',
    icon: Volume1
  },
  {
    level: 4,
    name: 'Firm',
    description: 'Direct accountability with support',
    example: '"You committed to this goal. Let\'s make it happen today."',
    icon: Volume1
  },
  {
    level: 5,
    name: 'Intense',
    description: 'Strong accountability and urgency',
    example: '"No excuses. Your goal is waiting. Get it done NOW!"',
    icon: Volume2
  }
];

export default function IntensitySlider({ value, onChange, className = '' }: IntensitySliderProps) {
  return (
    <div className={`space-y-6 ${className}`}>
      {/* Slider */}
      <div className="px-4">
        <div className="relative">
          <input
            type="range"
            min="1"
            max="5"
            value={value}
            onChange={(e) => onChange(parseInt(e.target.value))}
            className="w-full h-3 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"
            style={{
              background: `linear-gradient(to right, #fbbf24 0%, #f59e0b ${((value - 1) / 4) * 100}%, #e5e7eb ${((value - 1) / 4) * 100}%, #e5e7eb 100%)`
            }}
          />
          <div className="flex justify-between text-xs text-gray-500 mt-2">
            <span>Gentle</span>
            <span>Balanced</span>
            <span>Intense</span>
          </div>
        </div>
      </div>
    </div>
  );
}